










































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Post } from '../models/post'
import { PostUpdate } from '../models/post-update'
import RespondecoEditablePost from './editable-post/editable-post.vue'
import RespondecoPost from './post/post.vue'
import UnifyButton from '../../../shared/components/unify/unify-button.vue'
import RespondecoToolbar from '@/shared/components/toolbar/respondeco-toolbar.vue'
import RespondecoToolbarItem from '@/shared/components/toolbar/respondeco-toolbar-item.vue'
import { userIsAuthenticated } from '@/shared/utils/user'
import PostContainer from '@/business/post/components/post/post-container.vue'
import { Injector } from '@/config/dependency-injection'
import { NotificationService } from '@/shared/services/notification-service'
import PostReplies from '@/business/post/components/post/post-replies.vue'

@Component({
  name: 'respondeco-posts',
  components: {
    PostReplies,
    PostContainer,
    RespondecoToolbarItem,
    RespondecoToolbar,
    UnifyButton,
    RespondecoPost,
    RespondecoEditablePost,
  },
})
export default class RespondecoPosts extends Vue {
  @Prop({
    required: true,
    type: Boolean,
  })
  public readonly canComment!: boolean

  @Prop({
    required: true,
    type: Function,
  })
  public readonly canEdit!: (post: Post) => boolean

  @Prop({
    required: true,
    type: Boolean,
  })
  public readonly canReply!: boolean

  @Prop({
    type: Function,
  })
  public readonly createPost!: (post: PostUpdate) => Promise<any>

  @Prop({
    type: Function,
  })
  public readonly deletePost!: (post: Post) => Promise<any>

  @Prop({
    required: true,
    type: Array,
  })
  public readonly posts!: Post[]

  @Prop({
    required: true,
    type: Function,
  })
  public readonly updatePost!: (post: Post) => Promise<any>

  public creating: boolean = false
  public deleting: number | null = null
  public editing: number | null = null
  public replyTo: number | null = null
  public updating: number | null = null

  private notificationService = Injector.get(NotificationService)

  public get actionsDisabled(): boolean {
    return this.deleting !== null || this.editing !== null
  }

  public get isAuthenticated(): boolean {
    return userIsAuthenticated()
  }

  public cancelEditing(): void {
    this.editing = null
  }

  public cancelReplyTo(): void {
    this.replyTo = null
  }

  public editPost(postId: number): void {
    this.editing = postId
  }

  public handleCreate(post: PostUpdate): Promise<Post> {
    this.creating = true

    if (this.replyTo !== null) {
      post = {
        ...post,
        replyTo: this.replyTo,
      }
    }

    return this.createPost(post)
      .then(post => {
        this.notificationService.success('post.successfulCreate')

        return post
      })
      .finally(() => {
        this.creating = false
        this.replyTo = null
      })
  }

  public handleDelete(post: Post): void {
    this.deleting = post.id

    this.deletePost(post)
      .then(this.notificationService.successHandler('post.successfulDelete'))
      .finally(() => {
        this.deleting = null
      })
  }

  public handleUpdate(post: Post): Promise<Post> {
    this.updating = post.id

    return this.updatePost(post)
      .then(post => {
        this.cancelEditing()

        this.notificationService.success('post.successfulUpdate')

        return post
      })
      .finally(() => {
        this.updating = null
      })
  }

  public toggleReplyTo(postId: number): void {
    this.replyTo = postId
  }
}
